import { Fragment } from 'react';

const Organisation = ({ state, updateState, nextStep }) => {
  return (
    <Fragment>

      <h1 className="text-3xl font-semibold mb-6">Welcome,</h1>

      <p>You will need to have the following on hand to proceed.</p>

      <ul className="list-disc pl-5 my-6 space-y-2">
        <li><strong>Your bank account number and sort code</strong> <br/><small>If you are not trading, you can give this to us at a later stage.</small></li>
        <li><strong>3 months of card processing statements</strong> <br/><small>This is only required if you are moving from another merchant acquirer.</small></li>
        <li><strong>A copy of a recent bank account statement</strong><br/><small>This must be from last the 3 months, showing your business address.</small></li>
        <li><strong>Contact information for all people with significant control of your organisation.</strong><br /><small>They will all be sent a KYB request to validate their identity.</small></li>
      </ul>

      <p>This process takes around 15 minutes to complete.</p>

      <div className="mt-10">
        <button type="submit"
          onClick={() => nextStep()}
          className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
          Begin Application
        </button>
      </div>

    </Fragment>
  );
}

export default Organisation;
